import {CoinsSection_Sticky} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {
  COLORS,
  GenericIconName,
  Icon,
  Text,
  useInView,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {Badge} from './BasketCoinsView';

export const CoinsStickyRow: React.FC<{
  sticky: CoinsSection_Sticky;
  stickyHeight?: number;
}> = ({sticky, stickyHeight = 0}) => {
  const {ref, inView} = useInView<HTMLDivElement>({
    // This is a hack to prevent the sticky row from showing up when the user scrolls to the bottom of the page
    rootMargin: '99999px 0px -200px 0px',
  });

  const onClick = () => {
    ref.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  return (
    <>
      {!inView && (
        <StickyRow offset={stickyHeight} onClick={onClick}>
          <Icon asset={GenericIconName.Coins} size="S" />
          <StyledText size="px14" weight="w400">
            {sticky.title}
          </StyledText>
          <Badge>{sticky.badge}</Badge>
          <Icon asset={GenericIconName.ArrowRight} size="XS" />
        </StickyRow>
      )}
      <div ref={ref} />
    </>
  );
};

const StickyRow = styled.div<{offset: number}>`
  position: fixed;
  bottom: ${props => props.offset}px;
  z-index: 2;
  background-color: ${COLORS.White};
  padding: 0.5rem 1rem 0.5rem 1.25rem;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;

  border-top: 1px solid ${COLORS.Grey3};
  border-bottom: 1px solid ${COLORS.Grey3};
`;

const StyledText = styled(Text)`
  flex: 1;
`;
